const { recordLinkV2 } = require('utilities/tagging');

export const recordInicialComponent = () => {
    const customData = {
        event_name: "step_confirmation",
        pageName: "/loanContracting/step4/confirmation",
        sectionFamily: "banking",
        sectionCategory: "products",
        sectionName: "loans",
        serviceType: "productContracting",
        interactionType: "funnel",
        processType: "loanContracting",
        processStep: "step4",
        processDetail: "confirmation",
        productName: "<productType.productSubtype>"
    };

    recordLinkV2(customData);
}
export const recordbuildSignaturePattern = () => {
    const customData = {
        action: "start",
        format: "otpAuthentication",
        component: "OTP/SMS",
        element: "backend"
    };

    recordLinkV2(customData);
}
export const recordValidateSignaturePattern = () => {
    const customData = {
        action: "success",
        format: "otpAuthentication",
        component: "OTP/SMS",
        element: "backend"
    };

    recordLinkV2(customData);
}
